import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { PORT } from "../../config";
// import logo from '../../assets/img/logo_right-removebg.png';
import "./Login.css";
import { notify } from "react-notify-toast";
// import { LinkedInLoginButton } from "react-social-login-buttons";

import SignupContainer from "../Signup-Login/SignupContainer";
import GoogleDivider from "../Signup-Login/GoogleDivider";
import LinkToCreateAccount from "../Signup-Login/LinkToCreateAccount";
import LinkToInstitutionAccount from "../Signup-Login/LinkToInstitutionAccount";

import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import FormField from "../../Components/FormField/FormField";
import PasswordToggle from "../../Components/FormField/PasswordToggle";
import CheckableButton from "../../Components/CheckableButton/CheckableButton";
// import ButtonContainer from "../../Components/CheckableButton/ButtonContainer";
import Auth from "../../Auth/Auth";
import { API } from "../../API";
import { connect } from "react-redux";
import { updateSimpleQualification, updateToRoot } from "../../redux/homePage/homePage.actions";
import store from "../../redux/store";
import LoginToggle from "../Signup-Login/LoginToggle";
import { useLocation } from "react-router-dom";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const URL = PORT;
  const linkedinAPI = `${PORT}/auth/linkedin/login`;
  const proxyurl = "https://cors-anywhere.herokuapp.com/";
  const { updateToRoot, user, college, updateSimpleQualification } = props;
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  useEffect(() => {
    const token = window.localStorage.getItem("token");
    const userID = window.localStorage.getItem("userID");
    if (token) {
      console.log("user & college: ", user, college, userID);
      if (user && college?.email) {
        console.log("Should logout");
        Auth.logout();
      } else if (user && !college?.email && user._id !== userID) {
        console.log("user !== ID");
        Auth.logout();
      } else if (college?.email && !user) {
        const customerID = college.customer_id || college.personnel_id;
        if (customerID !== userID) {
          console.log("college !== ID");
          Auth.logout();
        } else {
          // console.log("go to profile")
          props.history.push("/Profile");
        }
      } else if (!user) {
        if (college?.email || college?.personnel_email) {
          // console.log("Go to profile")
          props.history.push("/Profile");
        }
      } else {
        // console.log("Go to dashboard")
        props.history.push("/Dashboard");
      }
    }

    if (props.location.state) {
      if (props.location.state.error) {
        notify.show(props.location.state.error, "error", 3000);
      }
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // if remember me checked the expire time would be three month
    // else 1 day
    // if (window.localStorage.getItem('userType') === 'null') {
    // notify.show("Please select to log in as Teacher or Institution/Provider.")
    // return;
    // }
    await API.login({
      user: {
        email,
        password,
      },
    })
      .then((res) => {
        switch (res.data.reason) {
          case "non-existent-user":
            console.log("non-existent-user res.data", res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/TeacherOption">
                  <b>register</b>.
                </a>
              </React.Fragment>
            );
            break;
          case "customer-existent-email":
            console.log(res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/LoginAsInstitution">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            window.localStorage.setItem('userType', 'institutionLogin');
            setTimeout(() => {
              window.location.href = '/LoginAsInstitution'
            }, 3000)
            break;
          case "personnel-existent-email":
            console.log(res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/LoginAsInstitution">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            window.localStorage.setItem('userType', 'institutionLogin');
            setTimeout(() => {
              window.location.href = '/LoginAsInstitution'
            }, 3000)
            break;
          case "user-existent-email":
            console.log(res.data);
            notify.show(
              <React.Fragment>
                {res.data.msg}
                <a href="/Login">
                  <b>login screen</b>.
                </a>
              </React.Fragment>
            );
            break;
          default:
            let userType = window.localStorage.getItem("userType");
            const requesViewId = window.localStorage.getItem("request_view_id");
            window.localStorage.clear();
            window.localStorage.setItem("userType", userType);
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("userID", res.data.user._id);
            Auth.login();
            API.getUserSafeData()
              .then(async (res) => {
                const user = res.data.user;
                // window.localStorage.setItem("user", JSON.stringify(user))
                // window.localStorage.setItem("shared_teacher", JSON.stringify(user))
                //Yuan: update user data to the root store
                updateToRoot(user);

                const resQua = await API.getSimpleQualification();
                const simpleQualifications = resQua?.data?.data
                updateSimpleQualification(simpleQualifications)

                const path = (user.role == 'admin')
                ?{
                  pathname: "/Statistics",
                }
                :{
                  pathname: "/dashboard",
                };

                const teacherId = window.sessionStorage.getItem("teacher_id")
                const listingPath = window.sessionStorage.getItem("listing_path")

                if(searchParams?.get("vtid") === user?._id && requesViewId && user.role !== 'admin') {
                  props.history.push(`/MyCalendar?request_view_id=${requesViewId}`)
                } else if (teacherId && teacherId == user?._id && listingPath && user.role !== 'admin') {
                  props.history.push(listingPath)
                  window.sessionStorage.removeItem("teacher_id")
                  window.sessionStorage.removeItem("listing_path")
                } else {
                  props.history.push(path);
                }
              })
              .catch((err) => {
                console.log(err);
              });
        }
      })
      .catch((err) => {
        if (err.response) {
          console.log(err.response.data);
          switch (err.response.data.reason) {
            case "non-existent-user":
              notify.show(
                <React.Fragment>
                  {err.response.data.msg}
                  <a href="/TeacherOption">
                    <b>register</b>.
                  </a>
                </React.Fragment>
              );
            case "User is not verified":
              notify.show(err.response.data.msg);
              break;
            case "Invalid Credentials":
              notify.show("Invalid email address or password.");
              break;
            default:
              notify.show("Error logging in. Please try again.");
              break;
          }
        } else {
          notify.show("Server error. Please try again later.");
        }
      });
  };

  /*  const hideEmailAndPassLoginForm = () => {
      document.getElementById('emailandpass-login-form').style.display = 'none';
    }
    const showEmailAndPassLoginForm = () => {
      document.getElementById('emailandpass-login-form').style.display = 'block';
    }*/

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  const responseFromGoogle = async (response) => {
    const { history } = props;
    // console.log(response.profileObj, response.tokenId)
    if (response.profileObj) {
      API.loginGoogle(response.tokenId)
        .then(async (res) => {
          const data = res.data.user;
          let path = "";
          if (data.email_verification_status) {
            let userType = window.localStorage.getItem("userType");
            window.localStorage.clear();
            window.localStorage.setItem("userType", userType);
            window.localStorage.setItem("token", res.data.token);
            window.localStorage.setItem("userID", res.data.user._id);
            Auth.login();
            // window.localStorage.setItem("user", JSON.stringify(data))
            // window.localStorage.setItem("shared_teacher",JSON.stringify(data))
            updateToRoot(data);

            const resQua = await API.getSimpleQualification();
            const simpleQualifications = resQua?.data?.data
            updateSimpleQualification(simpleQualifications)

            path = res.data.user.role == 'admin' 
            ?{
              pathname: "/Statistics",
            }
            :{
              pathname: "/dashboard",
            };
            history.push(path);
          } else {
            path = `/confirm?id=${data._id}`;
            window.location.href = path;
          }
        })
        .catch(async (err) => {
          if (err.response?.status === 401) {
            notify.show(
              <React.Fragment>
                {err.response?.data?.token ||
                  "No ReadyTeacher account associated with this Google account!"}
                <a href="/RegisterOption">
                  <b style={{ color: "rgb(121, 203, 202)" }}>
                    {" "}
                    Please sign up for your account.
                  </b>
                  .
                </a>
              </React.Fragment>
            );
          }
          // await axios({
          //   method: "post",
          //   url: `${URL}/googleRegistration/${response.profileObj.email}`,
          //   data: { email: response.profileObj.email },
          //   headers: {
          //     "Content-Type": "application/json",
          //   },
          // })
          //   .then((res) => {
          //     if (res.data.reason === "user-existent-email") {
          //       return notify.show(
          //         <React.Fragment>
          //           {res.data.msg}
          //           <a href="/Login">
          //             <b>login screen</b>.
          //           </a>
          //         </React.Fragment>
          //       );
          //     } else if (res.data.reason === "customer-existent-email") {
          //       return notify.show(
          //         <React.Fragment>
          //           {res.data.msg}
          //           <a href="/LoginAsInstitution">
          //             <b>login screen</b>.
          //           </a>
          //         </React.Fragment>
          //       );
          //     } else if (res.data.reason === "personnel-existent-email") {
          //       notify.show(
          //         <React.Fragment>
          //           {res.data.msg}
          //           <a href="/LoginAsInstitution">
          //             <b>login screen</b>.
          //           </a>
          //         </React.Fragment>
          //       );
          //     } else {
          //       const path = {
          //         pathname: "/beforeEmailConfirm",
          //       };
          //       history.push(path);
          //     }

          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        });
    } else {
      console.log("Fail");
      console.log(response);
    }
  };

  const redirectURL = `${window.location.href.split('#')[0]}`
  const handleLinkedInClick = () => {
    window.location.href = 'https://www.linkedin.com/oauth/v2/authorization' + 
      '?response_type=code' +
      '&client_id=78d14xqbsjs82q' + 
      '&redirect_uri=' + redirectURL.split('?')[0] +
      '&state=linkedin' + 
      '&scope=openid%20profile%20email';
  };
  
  const urlParams = new URLSearchParams(window.location.search);
  const newcode = urlParams.get('code');
  const handleLinkedInCallback = async (code) => {
    try {
      

      const response = await API.updateFromLinkedin(
        { code:code,
          redirect : redirectURL.split('?')[0]
        })
        let userLinkedin = response?.data?.data?.user;

        if(userLinkedin?.email_verification_status) {
          window.localStorage.setItem("userType", response.data.data.role);
          window.localStorage.setItem("token", response.data.data.token);
          window.localStorage.setItem("userID", response.data.data.user._id);
          Auth.login();
          updateToRoot(response.data.data.user);
          const path = response.data.data.role == 'admin' 
          ? {
            pathname: "/Statistics",
          }
          : {
            pathname: response.data.data.url,
            state: response.data.data.user
          };
          props.history.push(path);
        } else {
          let path = response?.data?.data?.url;
          window.location.href = path;
        }
    } catch (error) {
      console.error('Error:', error);
      // Handle errors
    }
  };
  if(newcode){
    if(urlParams.get('state') === 'linkedin'){
      handleLinkedInCallback(newcode)
    }else if(urlParams.get('state') === 'facebook'){

    }
  }


  return (
    <>
      <script src="https://accounts.google.com/gsi/client" async defer></script>
      <SignupContainer
        heading="Log in as"
        onSubmit={handleSubmit}
        toggle={
          <div className="row justify-content-center login-toggle-container">
            <LoginToggle />
          </div>
        }
        google={
          <GoogleDivider
            onSuccess={responseFromGoogle}
            onFailure={responseFromGoogle}
            buttonText="Log in with Google"
            linkedinText="Log in with Linkedin"
            linkedinClick={handleLinkedInClick}
            fbText="Log in with Facebook"
            fbClick={''}
          />
        }
      >
        {/*                <a
                  // href={linkedinAPI}
                  className="my-auto ml-3 mr-4 "
                  title="Login with Linkedin">
                  <LinkedInLoginButton
                    align={"center"}
                    className="h-60 w-60 linkedin-button my-auto "
                    text=""/>
                </a>
                <button
                  id="email-and-pssw-button"
                  title="Login with Email & Password"
                  className="h-60 w-60 btn btn-primary btn-block btn-c my-auto primary-button-no-margin-hover rt-button"
                  onClick={showEmailAndPassLoginForm}
                  ><i className='mdi mdi-email rt-button-icon'></i>
                </button>*/}
        {/* </div> */}

        {/* register with email & password form */}
        <div className="center-form">
          <FormField
            label="Email Address"
            type="email"
            id="email"
            placeholder="Enter Your Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            icon="email"
            autoFocus
            required
          />

          <FormField
            id="password"
            label="Password"
            type={showPassword ? "text" : "password"}
            placeholder="Enter Your Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon="lock"
            required
          >
            <PasswordToggle onClick={togglePassword} />
          </FormField>
        </div>

        <div className="d-flex form-check terms-and-conditions-check">
          {/* <div id="r8-balloon-radio-group-wrapper-login">
                <ul>
                  <li>
                    <input className="radio r8-radio-float"
                      type='checkbox'
                      id='remember'
                      name="balloon-radio-group" />
                  </li>
                </ul>
              </div>
              <label htmlFor='remember'>Remember me</label> */}
        </div>

        {/* large screen */}
        <div className="row qualification-footer small-screen-disappear justify-content-center">
          <div className="mb-3">
            <br />
            <ConfirmButton type="submit" className="signup-button">
              Submit
            </ConfirmButton>
          </div>
        </div>

        {/* small screen */}
        <div className="row qualification-footer small-screen-appear d-none">
          <div className="col-md-7 mb-3 sign-up-footer">
            <ConfirmButton type="submit">Submit</ConfirmButton>
          </div>
        </div>

        {/* link for if the user has an account already */}
        <div className="footer">
          <Link
            className="row qualification-footer justify-content-center"
            to="/resetSendEmail"
          >
            <br />
            Forgot Password?
          </Link>
          <LinkToCreateAccount />
        </div>
      </SignupContainer>
    </>
  );
};

// export default Login

function mapStateToProps(state) {
  return {
    user: state.user?.user,
    college: state.college?.user,
  };
}

const mapDispatchToProps = (dispatch) => ({
  updateToRoot: (user) => dispatch(updateToRoot(user)),
  updateSimpleQualification: (data) => dispatch(updateSimpleQualification(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
